import { Directive, Renderer2, ElementRef, OnChanges, SimpleChanges, Input } from '@angular/core';

@Directive({
    selector: '[appCustomProgressbar]'
})
export class CustomProgressbarDirective implements OnChanges {
    @Input() value: number;

    constructor(private renderer: Renderer2, private elementRef: ElementRef) {}

    ngOnChanges(changes: SimpleChanges) {
        const self = this;
        setTimeout(() => {
            const element = self.elementRef.nativeElement;
            const progresbarLabel = element.getElementsByClassName('p-progressbar-label');
            self.renderer.setStyle(progresbarLabel[0], 'width', self.value + '%');
        });
    }
}
